import React from 'react';
import { Header, Segment, Form, Button, Icon } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { validate } from 'react-email-validator';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class MailForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            types: [],
            typeId: '',
            mail: '',
            subject: '',
            text: '',

            typeErr: false,
            mailErr: false,
            subjectErr: false,
            textErr: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.sendMail = this.sendMail.bind(this);
    }

    componentDidMount() {
        // window.localStorage.clear();
        axios.get('/mail-types')
            .then(res => {
                const types = res.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));
                this.setState({ types });
            })
            .catch(err => {
                console.log('Failed to fetch comment types ');
            });
    }

    sendMail() {
        const {
            typeId, mail, subject, text
        } = this.state;

        if (!typeId || !validate(this.state.mail) || !subject || !text) {
            if (!typeId || !subject || !text) toast(<FormattedMessage id="contact.errorMess" />); else toast(<FormattedMessage id="contact.mailValidationError" />);
            if (!typeId) { this.setState({ typeErr: true }); } else { this.setState({ typeErr: false }); }
            if (!validate(this.state.mail)) { this.setState({ mailErr: true }); } else { this.setState({ mailErr: false }); }
            if (!subject) { this.setState({ subjectErr: true }); } else { this.setState({ subjectErr: false }); }
            if (!text) { this.setState({ textErr: true }); } else { this.setState({ textErr: false }); }
        } else {
            let mailObj = {
                mailFrom: mail,
                subject,
                text,
                mailType: { id: typeId }
            };

            axios.post('/mail/send/', { ...mailObj })
                .then(res => {
                    toast(<FormattedMessage id="contact.success" />);
                    this.setState({
                        typeId: '',
                        mail: '',
                        subject: '',
                        text: ''
                    });
                })
                .catch(err => {
                    toast(<FormattedMessage id="contact.error" />);
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Header as="h1"><FormattedMessage id="contact.comments" /></Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"><FormattedMessage id="contact.form" /></Header>
                    </Segment>
                    <Segment clearing>
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.subjectErr}>
                                    <label><FormattedMessage id="contact.title" /></label>
                                    <FormattedMessage id="contact.inputTitle">
                                        {(msg) => (<input
                                            value={this.state.subject}
                                            onChange={(e) => this.setState({ subject: e.target.value })}
                                            name="subject"
                                            placeholder={msg}
                                        />)}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field >
                                    <Form.Dropdown
                                        clearable
                                        placeholder={<FormattedMessage id="contact.selectCommentType" />}
                                        value={this.state.typeId}
                                        onChange={this.handleInputChange}
                                        name="typeId"
                                        options={this.state.types}
                                        label={<FormattedMessage id="contact.commentType" />}
                                        search
                                        fluid
                                        selection
                                        required
                                        error={this.state.typeErr}
                                    />
                                </Form.Field>
                                <Form.Field
                                    required
                                    error={this.state.mailErr}
                                >
                                    <label><FormattedMessage id="contact.email" /></label>
                                    <FormattedMessage id="contact.inputMail">
                                        {(msg) => (<input
                                            name="mail"
                                            value={this.state.mail}
                                            onChange={(e) => this.setState({ mail: e.target.value })}
                                            placeholder={msg}
                                        />)}
                                    </FormattedMessage>
                                </Form.Field>
                            </Form.Group>
                            <Form.Field
                                required
                                error={this.state.textErr}
                            >
                                <label><FormattedMessage id="contact.text_" /></label>
                                <FormattedMessage id="contact.text">
                                    {(msg) => (<Form.TextArea
                                        placeholder={msg}
                                        rows={7}
                                        value={this.state.text}
                                        onChange={(e) => this.setState({ text: e.target.value })}
                                    />)}
                                </FormattedMessage>
                            </Form.Field>
                            <Button
                                color="blue"
                                floated="right"
                                onClick={this.sendMail}
                                icon
                                labelPosition="left"
                            >
                                <Icon className="mail" /> <FormattedMessage id="common.send" /></Button>
                        </Form>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/MailForm/MailForm.js